/* eslint-disable import/export */
import store from '@/stores'
import Dygraph from 'dygraphs'
import { Component, Vue, Watch } from 'vue-facing-decorator'
import { ApolloComponentQueries } from './DataTableMixin'

export default interface GraphMixin {
    readonly vuexModuleName: string
}

@Component
export default class GraphMixin extends Vue {
  protected loaded = false
  protected graph!: Dygraph
  protected logscale = true

  get rowNum () {
    return (store.state[this.vuexModuleName] as any)?.rowNum as number
  }

  get apollo (): ApolloComponentQueries {
    return {}
  }

  changeScale () {
    this.logscale = !this.logscale
    this.graph.updateOptions({ logscale: this.logscale })
  }

  @Watch('rowNum')
  highlightProductionPoint () {
    if (this.rowNum !== null) {
      this.graph.setSelection(this.rowNum)
    }
  }

  resetZoom (): void {
    this.graph.resetZoom()
  }

  created () {
    Object.keys(this.apollo ?? {}).forEach(key => {
      this.$apollo.addSmartQuery(key, this.apollo![key])
    })
  }

  private getBase (n: number): number {
    return Math.pow(10, Math.floor(Math.log10(Math.abs(n)))) / 2
  }

  private snap (n: number, unit: number, round: (x: number) => number): number {
    return Number((round(n / unit) * unit).toPrecision(12))
  }

  ceil (n: number): number {
    return n === 0 ? 0 : this.snap(n, this.getBase(n), Math.ceil)
  }

  floor (n: number): number {
    return n === 0 ? 0 : this.snap(n, this.getBase(n), Math.floor)
  }
}
